module.exports = __webpack_public_path__ + "static/media/account.2c831c2b.svg";